import React from "react";
import { Button, Upload } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useCompanyModel } from "../companyModel";
import { useNavModel } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { importPropsConfig } from "@/utils/importFile";
import { YhAuth } from "@/components/auth/YhAuth";
import { IMD5ImgField } from "../companyTypes"
export const DataBox = () => {
    const { selectedRowKeys,
        selectedRow,
        md5List,
        setIVisibleDrawer,
        onRemove,
        setMd5FormVal,
        setMd5List
    } = useCompanyModel();
    const onAdd = () => {
        setIVisibleDrawer("add")
    }
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            return;
        }
        
        let { list } = selectedRow[0] as { list: IMD5ImgField[] }
        // console.log(list,"aaaaaaaaaa")
        setMd5FormVal(list ? list.map(item=>item.imgMd5) as string[]: [])
        setMd5List(list)
        setIVisibleDrawer("edit")
    }
    const onDelete = () => {
        if (selectedRowKeys.length === 0) {
            globalPrompt("message", { text: "请选择一条数据进行删除", type: "warning" });
            return;
        }
        onRemove(selectedRowKeys)
    }
    const action = <>

        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onAdd}
        >新增</Button>

        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onEdit}
        >编辑</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onDelete}
        >删除</Button>
    </>

    return (
        <YhBox title="公司荣誉列表" action={action}>
            <DataTable />
        </YhBox>
    )
}
